import React from 'react';
import useStyles from './styles';
import { parseJsonToEditorState } from '../../../services/editorJS/utils';

type Props = {
  script: string;
};

const ScriptWordCounter = ({ script }: Props) => {
  const classes = useStyles();
  const speechSpeed = 150;
  const parsedBlocks = parseJsonToEditorState(script);
  const blocks = parsedBlocks.blocks.filter((block) => block.type === 'paragraph');
  const countWords = blocks.reduce((count, block) => {
    const text = block?.data?.text || '';
    const clearedText = text.replace(/[^a-z0-9'\s]/gi, '');
    return count + clearedText.split(' ').filter((word: string) => word.length).length;
  }, 0);
  const seconds = (countWords / speechSpeed) * 60 || 0;
  const minutes = Math.floor(seconds / 60) || 0;
  const restSeconds = Math.floor(seconds % 60);
  const durationLabel = `${minutes}:${restSeconds < 10 ? '0' : ''}${restSeconds}`;
  const countWordsString = countWords.toLocaleString();

  return (
    <div className={classes.wordCount}>
      {countWordsString} {' '} words - {' '}
      {durationLabel}
    </div>
  );
};

export default ScriptWordCounter;
